export default __webpack_public_path__ + "static/media/modelC-cap.7336aa63.png";